import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/shared/integrations/supabase/client";

export interface AssetCategoryOption {
  id: string;
  name: string;
  descriptions: string[];
}

/** Hook: fetches all asset categories (id, name, subtype descriptions) for the dropdowns. */
export function useAssetCategories() {
  return useQuery<AssetCategoryOption[]>({
    queryKey: ["asset-categories"],
    queryFn: async (): Promise<AssetCategoryOption[]> => {
      const { data, error } = await supabase
        .from("asset_categories")
        .select("id, name, descriptions")
        .order("name", { ascending: true });

      if (error) throw error;
      return (data ?? []) as AssetCategoryOption[];
    },
    staleTime: 5 * 60 * 1000,
  });
}
